<template>
  <div class="tasks__item crms-task-item" :class="isActive? 'active' : ''">
    <div class="accordion-header" :class="activeAccordion? 'js-accordion-header' : ''"><slot name="title">{{ title }}</slot></div>
    <div class="accordion-body" :class="activeAccordion? 'js-accordion-body' : ''" style="display: block;">
      <div class="accordion-body__contents">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccordionItemComponent",
  props: {
    title: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false
    },
    activeAccordion: {
      type: Boolean,
      default: true
    }
  },
}
</script>

<style scoped>

</style>
